// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gportal/api/payment/v1/rpc.proto (package gportal.api.payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddAccountBalanceRequest, AddPromotionalCreditsRequest, ConsumeAccountBalanceRequest, CreateCheckoutPaymentIntentRequest, CreateCheckoutURLRequest, CreateSetupPaymentIntentRequest, GetAccountBalanceRequest, GetBalanceMigrationOfferRequest, GetBillingAddressRequest, GetCheckoutStatusRequest, GetLootPassFreeMonthCouponRequest, GetManagementUrlRequest, GetOrderInformationRequest, GetOrderPriceRequest, GetStartConfigurationsRequest, ListAppliedBalanceOperationsRequest, ListInvoicesRequest, ListSavedPaymentMethodsRequest, ListTransactionsRequest, MigrateAccountBalanceRequest, MigrateOwnAccountBalanceRequest, RecordOfflinePaymentRequest, ReverseAccountBalanceRequest, SetupPaymentMethodRequest, StartNewCustomerMigrationRequest, SubmitCheckoutRequest, SubmitPaymentMethodSetupRequest, UnwindConsumeAccountBalanceRequest } from "./requests_pb.js";
import { AddAccountBalanceResponse, AddPromotionalCreditsResponse, ConsumeAccountBalanceResponse, CreateCheckoutPaymentIntentResponse, CreateCheckoutURLResponse, CreateSetupPaymentIntentResponse, GetAccountBalanceResponse, GetBalanceMigrationOfferResponse, GetBillingAddressResponse, GetCheckoutStatusResponse, GetLootPassFreeMonthCouponResponse, GetManagementUrlResponse, GetOrderInformationResponse, GetOrderPriceResponse, GetStartConfigurationsResponse, ListAppliedBalanceOperationsResponse, ListInvoicesResponse, ListSavedPaymentMethodsResponse, ListTransactionsResponse, MigrateAccountBalanceResponse, MigrateOwnAccountBalanceResponse, RecordOfflinePaymentResponse, ReverseAccountBalanceResponse, SetupPaymentMethodResponse, StartNewCustomerMigrationResponse, SubmitCheckoutResponse, SubmitPaymentMethodSetupResponse, UnwindConsumeAccountBalanceResponse } from "./responses_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gportal.api.payment.v1.PaymentService
 */
export const PaymentService = {
  typeName: "gportal.api.payment.v1.PaymentService",
  methods: {
    /**
     * Return the payment provider management URL for the customer.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetManagementUrl
     */
    getManagementUrl: {
      name: "GetManagementUrl",
      I: GetManagementUrlRequest,
      O: GetManagementUrlResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available order configuration options with progressive disclosure.
     * Public: powers checkout step 1 before user authentication.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetOrderInformation
     */
    getOrderInformation: {
      name: "GetOrderInformation",
      I: GetOrderInformationRequest,
      O: GetOrderInformationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Calculates the final price for a fully configured order.
     * Public: called when GetOrderInformation returns complete=true.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetOrderPrice
     */
    getOrderPrice: {
      name: "GetOrderPrice",
      I: GetOrderPriceRequest,
      O: GetOrderPriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Resolves prices and product metadata for a set of start configurations.
     * Public: used by the GraphQL service to populate subscription product pricing.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetStartConfigurations
     */
    getStartConfigurations: {
      name: "GetStartConfigurations",
      I: GetStartConfigurationsRequest,
      O: GetStartConfigurationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateCheckoutURL creates a Chargebee hosted checkout page and returns
     * the URL the website should redirect to. Legacy flow gated behind the
     * `payment-components` feature flag being OFF — when the flag is ON, the
     * website calls CreateCheckoutPaymentIntent + SubmitCheckout instead.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.CreateCheckoutURL
     */
    createCheckoutURL: {
      name: "CreateCheckoutURL",
      I: CreateCheckoutURLRequest,
      O: CreateCheckoutURLResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateCheckoutPaymentIntent creates a Chargebee payment_intent that the
     * website hands to chargebee.components(...).create('payment', { paymentIntent })
     * so the subscription checkout form renders inline as native DOM (no
     * chargebee-hosted iframe). New-flow counterpart to CreateCheckoutURL —
     * the website picks one based on the `payment-components` feature flag.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.CreateCheckoutPaymentIntent
     */
    createCheckoutPaymentIntent: {
      name: "CreateCheckoutPaymentIntent",
      I: CreateCheckoutPaymentIntentRequest,
      O: CreateCheckoutPaymentIntentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SubmitCheckout finalizes a checkout once the user has completed the
     * Chargebee Payment Components form. The server uses payment_intent_id
     * when creating the subscription via subscription_for_items so the
     * just-tokenized payment method is used to activate.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.SubmitCheckout
     */
    submitCheckout: {
      name: "SubmitCheckout",
      I: SubmitCheckoutRequest,
      O: SubmitCheckoutResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Polls the processing status of a Payment Components checkout. The
     * result page calls this after SubmitCheckout returns and waits for
     * PROCESSED before navigating to the product-specific redirect URL —
     * PROCESSED only fires once the webhook reconciliation AND the
     * downstream provisioning (Gamecloud server deploy, Loot Pass
     * activation, etc.) have completed.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetCheckoutStatus
     */
    getCheckoutStatus: {
      name: "GetCheckoutStatus",
      I: GetCheckoutStatusRequest,
      O: GetCheckoutStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SetupPaymentMethod attaches a card to the authenticated customer using a
     * single-use Chargebee.js token (created via the publishable key in the
     * browser). Legacy "add payment method" entry point kept behind the
     * `payment-components` feature flag being OFF.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.SetupPaymentMethod
     */
    setupPaymentMethod: {
      name: "SetupPaymentMethod",
      I: SetupPaymentMethodRequest,
      O: SetupPaymentMethodResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateSetupPaymentIntent creates a Chargebee setup payment_intent
     * (amount=0) for the "add payment method" flow on the support page. No
     * subscription is involved — the intent is only used to capture and
     * tokenize a payment method. New-flow counterpart to SetupPaymentMethod.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.CreateSetupPaymentIntent
     */
    createSetupPaymentIntent: {
      name: "CreateSetupPaymentIntent",
      I: CreateSetupPaymentIntentRequest,
      O: CreateSetupPaymentIntentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SubmitPaymentMethodSetup attaches the payment method captured by a
     * setup payment_intent to the authenticated customer as a permanent
     * payment source.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.SubmitPaymentMethodSetup
     */
    submitPaymentMethodSetup: {
      name: "SubmitPaymentMethodSetup",
      I: SubmitPaymentMethodSetupRequest,
      O: SubmitPaymentMethodSetupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListSavedPaymentMethods returns a customer's chargeable Chargebee payment
     * sources, with no order involved. The legacy Webinterface checkout offers
     * them to migrated customers and passes the chosen one to
     * ConsumeAccountBalance as `payment_source_id`; the renewal mail reads them
     * for a named customer. No required role: with `customer_keycloak_id` set
     * the handler asserts the token subject matches it unless the caller holds
     * ROLE_SUPPORT, as GetAccountBalance does.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ListSavedPaymentMethods
     */
    listSavedPaymentMethods: {
      name: "ListSavedPaymentMethods",
      I: ListSavedPaymentMethodsRequest,
      O: ListSavedPaymentMethodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetLootPassFreeMonthCoupon creates or retrieves a one-time Loot Pass free month coupon
     * for a customer and returns the coupon code along with the item_price_id for URL construction.
     * Admin-only endpoint used by the PriceIncreaseNotificationTask.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetLootPassFreeMonthCoupon
     */
    getLootPassFreeMonthCoupon: {
      name: "GetLootPassFreeMonthCoupon",
      I: GetLootPassFreeMonthCouponRequest,
      O: GetLootPassFreeMonthCouponResponse,
      kind: MethodKind.Unary,
    },
    /**
     * RecordOfflinePayment records an offline "excess payment" on the customer's
     * Chargebee account — the API equivalent of the manual "Record an Offline
     * Payment" action. Used by the Webinterface PaysafeCard → Chargebee transfer
     * button to credit a top-up onto the Chargebee account after the WI books the
     * matching account-balance debit.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.RecordOfflinePayment
     */
    recordOfflinePayment: {
      name: "RecordOfflinePayment",
      I: RecordOfflinePaymentRequest,
      O: RecordOfflinePaymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AddAccountBalance credits an amount onto a migrated customer's Chargebee
     * account balance as an excess payment. Called by the Webinterface after it
     * books a top-up, and by the migration for the balance itself.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.AddAccountBalance
     */
    addAccountBalance: {
      name: "AddAccountBalance",
      I: AddAccountBalanceRequest,
      O: AddAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ConsumeAccountBalance spends part of a migrated customer's Chargebee
     * account balance on a legacy Webinterface charge — a renewal interval, a
     * modspace purchase, an order edit. All-or-nothing: on insufficient funds
     * the balance is left exactly as it was.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ConsumeAccountBalance
     */
    consumeAccountBalance: {
      name: "ConsumeAccountBalance",
      I: ConsumeAccountBalanceRequest,
      O: ConsumeAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetAccountBalance returns the customer's Chargebee balance buckets per
     * currency. No required role: the handler asserts the token subject equals
     * `customer_keycloak_id` unless the caller holds ROLE_SUPPORT, so a customer
     * can read their own wallet and only support can read anyone else's.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetAccountBalance
     */
    getAccountBalance: {
      name: "GetAccountBalance",
      I: GetAccountBalanceRequest,
      O: GetAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AddPromotionalCredits grants promotional credits — the discount
     * instrument, distinct from the account balance. Supporter gifts and the
     * monthly partner payout route here rather than to AddAccountBalance.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.AddPromotionalCredits
     */
    addPromotionalCredits: {
      name: "AddPromotionalCredits",
      I: AddPromotionalCreditsRequest,
      O: AddPromotionalCreditsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ReverseAccountBalance takes back an amount previously credited to the
     * account balance — a refund, a chargeback or a supporter correcting a
     * booking mistake. The instrument used depends on whether the money is
     * still unapplied, and is reported back in the response.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ReverseAccountBalance
     */
    reverseAccountBalance: {
      name: "ReverseAccountBalance",
      I: ReverseAccountBalanceRequest,
      O: ReverseAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * UnwindConsumeAccountBalance undoes an applied ConsumeAccountBalance whose
     * caller rolled back the work it paid for. The invoice's payments are
     * removed, so the money returns to the balance as excess, and the invoice is
     * voided. The consume's operation row is then closed as failed, so a retry
     * under the same reference may carry a different amount. Refused when the
     * invoice has been credited or paid by a payment method: those are refunded
     * through ReverseAccountBalance instead. Idempotent per reference.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.UnwindConsumeAccountBalance
     */
    unwindConsumeAccountBalance: {
      name: "UnwindConsumeAccountBalance",
      I: UnwindConsumeAccountBalanceRequest,
      O: UnwindConsumeAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * MigrateAccountBalance moves one customer's Webinterface account balance
     * onto Chargebee and sets the one-way `balance_migrated_at` flag. Idempotent
     * per (customer, currency); `dry_run` reports what a real run would do and
     * writes nothing.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.MigrateAccountBalance
     */
    migrateAccountBalance: {
      name: "MigrateAccountBalance",
      I: MigrateAccountBalanceRequest,
      O: MigrateAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetBalanceMigrationOffer answers whether the caller may move their legacy
     * balance to Chargebee themselves, and how much, for the given order
     * (TV-2188). Read-only: it creates nothing in Chargebee. The website shows the
     * offer on both checkout flows.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetBalanceMigrationOffer
     */
    getBalanceMigrationOffer: {
      name: "GetBalanceMigrationOffer",
      I: GetBalanceMigrationOfferRequest,
      O: GetBalanceMigrationOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * MigrateOwnAccountBalance is MigrateAccountBalance for the customer
     * themselves (TV-2188): the website offers it in the checkout when
     * GetBalanceMigrationOffer returns an `offer`. The customer is
     * always the caller, never a request field. Refused without the
     * `cb-self-migration` feature flag, or when the customer is excluded from the
     * migration. Idempotent.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.MigrateOwnAccountBalance
     */
    migrateOwnAccountBalance: {
      name: "MigrateOwnAccountBalance",
      I: MigrateOwnAccountBalanceRequest,
      O: MigrateOwnAccountBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * StartNewCustomerMigration asks mono to start a customer it did not create
     * itself on the Chargebee balance (TV-2134). The Webinterface calls it right
     * after its first-login registration has committed the customer. It only
     * queues the work: whether the customer is migrated is mono's decision —
     * switched on for this region, created after the cutover, nothing on the
     * legacy ledger — and never the caller's. `queued` is false when it does not
     * apply. Idempotent.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.StartNewCustomerMigration
     */
    startNewCustomerMigration: {
      name: "StartNewCustomerMigration",
      I: StartNewCustomerMigrationRequest,
      O: StartNewCustomerMigrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListAppliedBalanceOperations returns the consumes this side has applied, so
     * a caller can find the ones its own ledger never recorded.
     *
     * It exists because the two halves of a spend are not one transaction and
     * cannot be made into one: the Webinterface charges inside a database
     * transaction, and a rollback after the charge takes the order and the
     * offsetting ledger row with it while the Chargebee invoice stands. The
     * customer is charged and has nothing, and — this is the part that makes an
     * RPC necessary — NOTHING LOCAL SHOWS IT. A migrated customer's ledger is
     * supposed to read zero, so the loss is invisible in the one number that
     * would otherwise reveal it, and the reconciliation sweep's balance-shaped
     * findings cannot see it either.
     *
     * The answer is deliberately split. This side knows what it charged; only the
     * Webinterface knows what it recorded. So this returns candidates and the
     * caller filters them against its own ledger — see
     * ListAppliedBalanceOperationsRequest for why `wi_transaction_id` is not the
     * answer.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ListAppliedBalanceOperations
     */
    listAppliedBalanceOperations: {
      name: "ListAppliedBalanceOperations",
      I: ListAppliedBalanceOperationsRequest,
      O: ListAppliedBalanceOperationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListTransactions returns the customer's own money history — the Webinterface
     * ledger rows they are shown, newest first. The rows a customer may see are the
     * Webinterface's rule, not this service's: everything after their most recent
     * write-off, minus the bookkeeping rows that mirror a balance Chargebee now owns.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ListTransactions
     */
    listTransactions: {
      name: "ListTransactions",
      I: ListTransactionsRequest,
      O: ListTransactionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListInvoices returns the customer's legacy invoices, one per billing period.
     * Periods Chargebee bills are excluded at source, so a period cannot appear here
     * and on a Chargebee invoice both.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.ListInvoices
     */
    listInvoices: {
      name: "ListInvoices",
      I: ListInvoicesRequest,
      O: ListInvoicesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetBillingAddress returns the address a legacy invoice is made out to, and the
     * countries it may name. Read only — storing an address is still the legacy page's.
     *
     * @generated from rpc gportal.api.payment.v1.PaymentService.GetBillingAddress
     */
    getBillingAddress: {
      name: "GetBillingAddress",
      I: GetBillingAddressRequest,
      O: GetBillingAddressResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

